import { useDispatch, useSelector } from 'react-redux';
import { parse, format } from 'date-fns';
import '../../css/base.css';
import welcome1 from '../../img/welcome1a.jpg';
import { setPage, setSection } from '../../store/AppSlice';

const Welcome = () => {

  const dispatch = useDispatch();

  const appstate = useSelector((state) => state.appState);

  const isVIP = () => {
    if (appstate.vip === true) {
      return (
        <p className="welcome-text">As our special guests you can use our kayaks so check out the kayaks section of 'Your Stay'
                                    for extra information. 
        </p>
        )
    } 
  }

  const getTabletText = () => {
    if (appstate.formFactor === "TABLET") {
    return (
      <div className="generalText">
        <div className="generalTextBox">
          {isVIP()}
          <p className="welcome-text">The cottage is a perfect base for exploring this wonderful part of Scotland.  It's cozy, comfortable and well equipped.  Perfect for 
            relaxing days watching the stunning seascapes, mountains and wildlife from any of the windows overlooking the sea loch.  For the more
            adventurous there are walks, mountains and beaches to explore nearby and further afield. 
          </p>
          <p className="welcome-text">We hope you have a wonderful time in Arnisdale and experience all the best this beautiful area has to offer.  Browse the cottage website 
            for ideas and suggestions of things to do and see during your visit.  The 
            <span className="navigate-span"><a className="navigate-button" onClick={navigateToYourStay}>Your Stay</a></span>
            section on our website contains all the practical information 
            you need to know about the cottage including details on directions and access.
          </p>
        </div>
      </div>
    )
    }
  }
  const getWelcomeText = (location) => {
    
    if (location === "FIRST" && appstate.formFactor === "TABLET") {
      return (
        <div className="generalText">
          <div className="generalTextBox">
            {isVIP()}
            <p className="welcome-text">The cottage is a perfect base for exploring this wonderful part of Scotland.  It's cozy, comfortable and well equipped.  Perfect for 
              relaxing days watching the stunning seascapes, mountains and wildlife from any of the windows overlooking the sea loch.  For the more
              adventurous there are walks, mountains and beaches to explore nearby and further afield. 
            </p>
            <p className="welcome-text">We hope you have a wonderful time in Arnisdale and experience all the best this beautiful area has to offer.  Browse the cottage website 
              for ideas and suggestions of things to do and see during your visit.  The 
              <span className="navigate-span"><a className="navigate-button" onClick={navigateToYourStay}>Your Stay</a></span>
              section on our website contains all the practical information 
              you need to know about the cottage including details on directions and access.
            </p>
          </div>
        </div>
      )
    } else if (location === "SECOND" && appstate.formFactor === "MOBILE") {
      return (
        <div className="col-12 col-md-6 order-5 imagesBackgroundColour">
          <div className="generalText">
            <div className="generalTextBox">
              {isVIP()}
              <p className="welcome-text">The cottage is a perfect base for exploring this wonderful part of Scotland.  It's cozy, comfortable and well equipped.  Perfect for 
                relaxing days watching the stunning seascapes, mountains and wildlife from any of the windows overlooking the sea loch.  For the more
                adventurous there are walks, mountains and beaches to explore nearby and further afield. 
              </p>
              <p className="welcome-text">We hope you have a wonderful time in Arnisdale and experience all the best this beautiful area has to offer.  Browse the cottage website 
                for ideas and suggestions of things to do and see during your visit.  The 
                <span className="navigate-span"><a className="navigate-button" onClick={navigateToYourStay}>Your Stay</a></span>
                section on our website contains all the practical information 
                you need to know about the cottage including details on directions and access.
              </p>
            </div>
          </div>
        </div>
      )
    }
  }

  const getArrivalDate = () => {
    let parsedArrivalDate = parse(appstate.arrivalDate, 'yyyyMMdd', new Date());
    let arrivalDate = format(parsedArrivalDate, "EEEE") + " the " + format(parsedArrivalDate, "do") + " of " + format(parsedArrivalDate, "MMMM") + " " + format(parsedArrivalDate, "y");
    return arrivalDate;
  }

  const navigateToYourStay = () => {
    dispatch(setSection("COTTAGE"));
    dispatch(setPage("YOUR_STAY"));
  }

  return (
    <div className="row">
      <div className="col-12 col-md-6 order-1 imagesBackgroundColour welcome-text-padding">
        <div className="generalText">
          <div className="generalTextBox">
            <p className="welcome-heading" >Welcome {appstate.guestNames}!
            </p>
            <p className="welcome-text">We are delighted that you have chosen to visit Shore Cottage for your holiday starting on <strong>{getArrivalDate()}</strong>.  Here's the view you can look forward to.
            </p>
            {getWelcomeText("FIRST")}
          </div>
        </div>
      </div>
      <div className="col-2 col-md-1 order-2 order-md-4 imagesBackgroundColour no-padding">
      </div>
      <div className="col-7 col-md-4 order-3 order-md-5 imagesBackgroundColour no-padding">
          <img src={welcome1} alt="Welcome Door" className="gallery-image" />
      </div>
      <div className="col-3 col-md-1 order-4 order-md-6 imagesBackgroundColour no-padding">
      </div>
      {getWelcomeText("SECOND")}
    </div>
  );
}

export default Welcome
